import { SourceBaseView } from "../api-generated";

export const getPlatzSourceLink = (source: SourceBaseView): string =>
  `/sources/${source.type}/${source.id}`;
